import React, { useEffect, useRef } from 'react';
import styles from './AboutSection.module.css';
import buildingImg from '../../assets/about-building.jpg';
import qrImg from '../../assets/qr-code.jpg';
// import qrImg from '../../assets/qr-code.png';

const amenities = [
    { value: '70,000', unit: 'sq. ft.', label: 'Of Amenities' },
    { value: '29', unit: 'Floors', label: 'Of Residences' },
    { value: '3.6', unit: 'Acres', label: 'Total Area' },
];

const AboutSection = () => {
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(styles.visible);
                    }
                });
            },
            { threshold: 0.15 }
        );

        const els = sectionRef.current?.querySelectorAll('[data-animate]');
        els?.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    return (
        <section className={styles.section} ref={sectionRef}>
            <div className={styles.topGrid}>
                <div className={styles.textBlock}>
                    <div className={styles.eyebrow} data-animate>
                        <span className={styles.eyebrowLine}></span>
                        AMENITIES
                    </div>

                    <h2 className={styles.heading} data-animate>
                        ~70,000 sq. ft.
                        <em>of Amenities</em>
                    </h2>

                    <p className={styles.body} data-animate>
                        Spread across multiple levels, The Everett offers a comprehensive
                        set of amenities designed for everyday use — not just show.
                        Every facility is curated to elevate how you live, not merely
                        how your home looks.
                    </p>

                    {/* <div className={styles.rera} data-animate>
                        <div className={styles.reraLeft}>
                            <span className={styles.reraLabel}>MahaRERA Registered</span>
                            <span className={styles.reraNumber}>PM1261012600059</span>
                            <a
                                href="https://maharera.mahaonline.gov.in"
                                target="_blank"
                                rel="noreferrer"
                                className={styles.reraLink}
                            >
                                maharera.mahaonline.gov.in
                            </a>
                        </div>
                        <div className={styles.qrWrapper}>
                            <img
                                src={qrImg}
                                alt="MahaRERA QR Code"
                                className={styles.qrImg}
                            />
                        </div>
                    </div> */}
                </div>

                <div className={styles.imageWrapper} data-animate>
                    <img
                        src={buildingImg}
                        alt="Aerial view of the building"
                        className={styles.buildingImg}
                    />
                    <div className={styles.imgCaption}>Artist's Impression</div>
                    <div className={styles.floatCard}>
                        <span className={styles.floatValue}>~70K</span>
                        <span className={styles.floatLabel}>sq. ft. of world-class amenities</span>
                    </div>
                </div>
            </div>


        </section>
    );
};

export default AboutSection;